var exports = {
  "r9": "MenuItem.module__disabled___Y05xN1",
  "W$": "MenuItem.module__subtext___Y05xN1",
  "z": "MenuItem.module__sliderItem___Y05xN1",
  "Ry": "MenuItem.module__sliderHeader___Y05xN1",
  "KF": "MenuItem.module__sliderLabel___Y05xN1",
  "rv": "MenuItem.module__sliderValue___Y05xN1",
  "xJ": "MenuItem.module__sliderContainer___Y05xN1",
};

module.exports = exports;
